<template>
  <div class="login">
    <div class="head">
      <div class="img">
        <img src="../assets/img/head.png">
      </div>
      <p>方心科技移动缴费系统</p>
    </div>
    <div class="register">
      请通过手机验证码找回密码。<font @click="$router.push('/login')">返回登录</font>
    </div>
    <!--登陆-->
    <form action="javascript:;">
      <div class="item">
        <input type="text" name="name" v-model="user.phoneNum" maxlength="11" placeholder="请输入您的手机号" autocomplete="off" class="name">
      </div>
      <div class="item">
        <input type="text" name="vcode" v-model="user.verificationCode" maxlength="6" placeholder="请输入验证码" autocomplete="off" class="vcode">
        <span v-if="disabled" style="background-color: #666666">重新发送({{count}})</span>
        <span v-else id="vcode" @click="sendCode">发送验证码</span>
      </div>
      <div class="item">
        <input type="password" v-model="user.password" name="password" placeholder="请设置您的密码" autocomplete="off" class="password">
      </div>
      <div class="item">
        <input type="password" v-model="user.rePassword" name="passwordcf" placeholder="请确认您的密码" autocomplete="off" class="password">
      </div>
      <div class="submit" @click="doRegister"><button>找回密码</button></div>
    </form>
    <!--尾部-->
<!--    <div class="footer">-->
<!--      &lt;!&ndash;      <img src="../assets/img/logo.png">&ndash;&gt;-->
<!--      <p>注册使用就表示同意用户协议<a href="javascript:;">条款</a>和<a href="javascript:;">隐私</a>政策</p>-->
<!--    </div>-->
  </div>
</template>
<script>
    export default {
        name: "forget",
        data(){
            return {
                count: 60,
                disabled: false,
                user: {
                    phoneNum: "",
                    password: "",
                    rePassword: "",
                    verificationCode: "",
                },
                remember: false,
            }
        },
        mounted() {

        },
        methods: {
            sendCode(){
                if( !this.user.phoneNum ) {
                    this.$toast("请输入手机号码！")
                } else {
                    if(!(/^1[3456789]\d{9}$/.test(this.user.phoneNum))){
                        this.$toast("手机号码有误，请重填")
                    } else {
                        this.$http.post("/external/appUser/send/code", { phoneNum: this.user.phoneNum }).then(res=>{
                            if( res.code == 200 ) {
                                this.disabled = true
                                this.$toast.success("发送成功，请注意查收！")
                                let ts = setInterval(()=>{
                                    console.log(this.count, 12345)
                                    this.count--
                                    if( this.count == 0 ) {
                                        clearInterval(ts)
                                        this.disabled = false
                                        this.count = 60
                                    }
                                }, 1000)
                            }
                        })
                    }
                }
            },
            doRegister(){
                if( !this.user.password || !this.user.rePassword || !this.user.phoneNum || !this.user.verificationCode ) {
                    this.$toast.error("请完善信息再提交！")
                } else {
                    if( this.user.password != this.user.rePassword ) {
                        this.$toast.error("两次输入密码不一致，请修改！")
                    } else {
                        this.$http.put("/external/appUser/edit", this.user).then(res=>{
                            if( res.code == 200 ) {
                                this.$toast.success("找回成功！")
                                this.$router.push("/login")
                            } else {
                                this.$toast.error(res.msg)
                            }
                        })
                    }
                }
            }
        }
    }
</script>

<style lang="less">
  @iconSize: 70px;
  .login{
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    background: url(../assets/img/top_bg.png) top left no-repeat;
    background-size: 100%;
    .head{
      width: 100%;
      height: 20%;
      .img{
        width: @iconSize;
        height: @iconSize;
        background: #FFFFFF;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 10%;
        text-align: center;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img{
        width: @iconSize - 20px;
      }
      p{
        text-align: center;
        color: #FFFFFF;
        font-size: 16px;
      }
    }
    .register{
      margin: 60px 20px 0 20px;
      font-size: 14px;
      text-align: right;
      color: #888;
      font{
        color: #1f6ecf;
      }
    }
    /*登陆表单*/
    form {
      width: 100%;
      height: auto;
      overflow: hidden;
      padding: 20px 20px 20px 20px;
      .item{
        display: flex;
        align-items: center;
        width: calc(100% - 40px);
        height: 40px;
        margin-bottom: 30px;
        color: #333333;
        input{
          width: 100%;
          height: 100%;
          display: inline-block;
          border: 1px solid #ebebeb;
          border-radius: 20px;
          box-shadow: 0px 0px 10px rgba(200,200,200,.1);
          padding-left: 35px;
          outline: none;
          &.name{
            background: url(../assets/img/icon-phone.png) left 15px center no-repeat;
            background-size: 12px auto;
          }
          &.vcode{
            background: url(../assets/img/icon-verify.png) left 15px center no-repeat;
            background-size: 16px auto;
          }
          &.password{
            background: url(../assets/img/icon-lock.png) left 15px center no-repeat;
            background-size: 12px auto;
          }
        }
        span{
          flex-shrink: 0;
          display: inline-block;
          width: 100px;
          margin-left: 5px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          background: #1f6ecf;
          font-size: 14px;
          color: #fff;
          text-align: center;
        }
      }
      .forget{
        display: flex;
        width: calc(100% - 40px);
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        .remember{
          font-size: 13px;
        }
        .for{
          font-size: 13px;
          color: #1f6ecf;
        }
      }
      .submit{
        width: calc(100% - 40px);
        button{
          border: none;
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 18px;
          color: #FFFFFF;
          border-radius: 20px;
          outline: none;
          box-shadow: 0 5px 5px rgba(31,110,207,.2);
          display: inline-block;
          width: 100%;
          background: #1f6ecf;
        }
      }
    }
    /*尾部*/
    .footer{
      text-align: center;
      padding-top: 20px;
      p{
        font-size: 14px;
        color: #666666;
        text-align: center;
        padding: 10px 0 5px 0;
        letter-spacing: 1px;
        a{
          color: #078dda;
        }
      }
    }
  }
</style>
